import { Switch } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

type Color =
  | "default"
  | "primary"
  | "secondary"
  | "error"
  | "info"
  | "success"
  | "warning";

type Props = {
  name: string;
  disabled?: boolean;
  color?: Color;
  reversedValue?: boolean;
};

const SwitchField = ({
  name,
  disabled,
  color = "primary",
  reversedValue = false,
}: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Switch
          disabled={disabled}
          checked={reversedValue ? !field.value : field.value || false}
          onChange={(e) =>
            field.onChange(reversedValue ? !e.target.checked : e.target.checked)
          }
          color={color}
        />
      )}
    />
  );
};

export default SwitchField;
